// extracted by mini-css-extract-plugin
export default {"main":"article_main__ohj-y","italicized":"article_italicized__laih0","title":"article_title__DA+y9"};